import { ca } from '@cian/analytics';
import { TAnalyticsOfferStatus } from '../../../../types/analytics';

interface ITrackRetryPaymentClickParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  amount: number;
}

export const trackRetryPaymentClick = (params: ITrackRetryPaymentClickParams) => {
  const { analyticsOfferStatus, amount } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'retry_to_pay',
    label: amount,
  });
};
